/**
 * 方案API
 *
 * @Author:szs
 * @Date: 2021-08-28
 * @Last Modified time: 2021-08-28
 */

import http from '@/utils/request'
const apis = {
  // 获取方案列表
  getPlanList(dto) {
    return http.get({
      url: '/pc/photosynthesis/getPlanList',
      data: dto
    })
  },

  // 获取全部方案
  getPlanAll(dto) {
    return http.get({
      url: '/pc/photosynthesis/getPlans',
      data: dto
    })
  },

  // 获取方案
  getPlan(dto) {
    return http.get({
      url: '/pc/photosynthesis/getPlanInfo',
      data: dto
    })
  },
  // 获取全部模型决策
  getGrowthModelDecisions(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getGrowthModelDecisions',
      data: dto
    })
  },
  // 保存方案
  savePlan(dto) {
    return http.post({
      url: '/pc/photosynthesis/savePlan',
      data: dto
    })
  },

  // 删除方案
  delPlan(id) {
    return http.post({
      url: '/pc/photosynthesis/deletePlan',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  // 获取分组方案列表
  getGroupPlanList(dto) {
    return http.get({
      url: '/pc/photosynthesis/getGroupPlanList',
      data: dto
    })
  },

  // 保存分组方案
  saveGroupPlan(dto) {
    return http.post({
      url: '/pc/photosynthesis/saveGroupPlan',
      data: dto
    })
  },

  // 删除分组方案
  delGroupPlan(id) {
    return http.post({
      url: '/pc/photosynthesis/deleteGroupPlan',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  // 启动/停止分组方案
  noOrOffGroupPlan(dto) {
    return http.post({
      url: '/pc/photosynthesis/noOrOffPlan',
      data: dto
    })
  },

  // 获取分组方案列表(新)(决策模型id)
  getNewGroupPlanList(dto) {
    return http.get({
      url: '/pc/photosynthesis/getNewGroupPlanList',
      data: dto
    })
  },

  /**
   *历史参数控制
   */
  // 获取生长模型历史参数控制列表
  getGrowthModelHisParamControlList(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getGrowthModelHisParamControlList',
      data: dto
    })
  },

  // 获取生长模型历史参数控制传感器列表(生长模型历史参数控制id)
  getGrowthModelHisParamControlNumericalList(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getGrowthModelHisParamControlNumericalList',
      data: dto
    })
  },

  // 获取生长模型历史参数控制传感器历史数据图表
  getGrowthModelHisParamControlNumericalChart(dto) {
    return http.get({
      url: '/pc/growthModelDecision/getGrowthModelHisParamControlNumericalChart',
      data: dto
    })
  }
}
export default apis
